import MedicationItemScreen from "app/screens/residents/show/MedicationItemScreen";

export default function ResidentMedicationPage() {
  return <MedicationItemScreen />;
}
